import permissions from '../../data/permissions';

export default [
    {
        name: "PurchasePaymentModeList",
        path: "payment-modes",
        component: () => import('./../../views/purchase/PurchasePaymentModeListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment_account.index}
    },
    {
        name: "PurchasePaymentModeDisplay",
        path: "payment-mode/:id",
        component: () => import('./../../views/purchase/PurchasePaymentModeDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment_account.read }
    },
    {
        name: "PurchasePaymentModeAccountCreate",
        path: "payment-mode/:id/account",
        component: () => import('./../../views/purchase/PurchasePaymentModeAccountCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment_account.create }
    }
];